<template>
  <q-page padding>
    <base-form :resource="$route.meta.resource" />
  </q-page>
</template>

<script>
export default {
  name: 'AddForm'
}
</script>

<style>
</style>
